import { FilterTypes } from '../../../models/filterEnums.model';
import { FilterCriteria } from '../shared/filter-criteria.model';
import { TreeNode } from 'primeng/api';

export class CategoryOfCompanyCriteria extends FilterCriteria {
  public override title = 'Category of Company';
  public override type: FilterTypes = FilterTypes.CategoryOfCompany;
  categorySelection: TreeNode[] = null;

  public override validate(): boolean {
    return this.categorySelection != null && this.categorySelection.length > 0;
  }

  public override toString(): string {
    if (this.categorySelection && this.categorySelection.length > 0) {
      return 'Company size: ' + this.categorySelection.map((selection) => selection.label).join(', ');
    }
    return '';
  }
}
